import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "gatsby";

import {PropertySearchUrl} from "../../common/utils/property_utils";
import { defaultArea_Slug } from "../../common/constant";

import "./Breadcrumb.scss";

const PropertyDetailsBreadCrumb = ({property_data, location}) => {

    let search_url = location?.state?.search_url ? location?.state?.search_url : PropertySearchUrl(property_data.department, property_data.search_type)+"in-"+defaultArea_Slug+"/";

    let serach_text = "for Sale";

    if(property_data.search_type === "lettings"){
        serach_text = "to Rent";
    }

    let property_text = "Property";
    if(property_data.department === "commercial"){
        property_text = "Commercial property";
    }
    if(property_data.department === "auction"){
        property_text = "Auction property";
    }

    return (
        <React.Fragment>
            <section className="breadcrumb-section property_details">
                <Container>
                    <Row>
                        <Col>
                            <ol class="breadcrumb d-flex align-items-center">
                                <li class="breadcrumb-item first-item">
                                    <Link to={`${search_url}`} role="button" tabindex="0">Back to Search Results</Link>
                                </li>
                                <li class="breadcrumb-item d-none d-lg-inline-block">
                                    <Link to={"/"} role="button" tabindex="1">Home</Link>
                                </li>
                                <li class="breadcrumb-item d-none d-lg-inline-block">
                                    <Link to={`${search_url}`} role="button" tabindex="2">{property_text} {serach_text}</Link>
                                </li>
                                <li class="breadcrumb-item d-none d-lg-inline-block pointer-none">
                                    <a href="javascript:;" role="button" tabindex="3">{property_data.title}</a>
                                </li>
                            </ol>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default PropertyDetailsBreadCrumb;
